import { c as _c } from "react/compiler-runtime";
import { IcoWarningSmall16 } from '@onefootprint/icons';
import type { OnboardingStatus } from '@onefootprint/request-types';
import type { EntityStatus } from '@onefootprint/request-types/dashboard';
import { Badge } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import getBadgeVariantByStatus from '@/utils/get-badge-variant-by-status';
export type StatusBadgeProps = {
  requiresManualReview?: boolean;
  status: OnboardingStatus | EntityStatus;
};
const StatusBadge = t0 => {
  const $0 = _c(18);
  const {
    requiresManualReview: t1,
    status
  } = t0;
  const requiresManualReview = t1 === undefined ? false : t1;
  let t2;
  if ($0[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "entityStatuses"
    };
    $0[0] = t2;
  } else {
    t2 = $0[0];
  }
  const {
    t
  } = useTranslation("common", t2);
  let t3;
  if ($0[1] !== requiresManualReview || $0[2] !== status) {
    t3 = getBadgeVariantByStatus(status, requiresManualReview);
    $0[1] = requiresManualReview;
    $0[2] = status;
    $0[3] = t3;
  } else {
    t3 = $0[3];
  }
  const badgeVariant = t3;
  let t4;
  if ($0[4] !== status) {
    t4 = $ => $[status];
    $0[4] = status;
    $0[5] = t4;
  } else {
    t4 = $0[5];
  }
  let t5;
  if ($0[6] !== t || $0[7] !== t4) {
    t5 = t(t4);
    $0[6] = t;
    $0[7] = t4;
    $0[8] = t5;
  } else {
    t5 = $0[8];
  }
  let t6;
  if ($0[9] !== t5) {
    t6 = <span>{t5}</span>;
    $0[9] = t5;
    $0[10] = t6;
  } else {
    t6 = $0[10];
  }
  let t7;
  if ($0[11] !== badgeVariant || $0[12] !== requiresManualReview) {
    t7 = requiresManualReview && <div className="ml-0.5 relative top-[-1px]"><IcoWarningSmall16 color={badgeVariant} /></div>;
    $0[11] = badgeVariant;
    $0[12] = requiresManualReview;
    $0[13] = t7;
  } else {
    t7 = $0[13];
  }
  let t8;
  if ($0[14] !== badgeVariant || $0[15] !== t6 || $0[16] !== t7) {
    t8 = <div className="flex items-center"><Badge variant={badgeVariant} className="text-nowrap">{t6}{t7}</Badge></div>;
    $0[14] = badgeVariant;
    $0[15] = t6;
    $0[16] = t7;
    $0[17] = t8;
  } else {
    t8 = $0[17];
  }
  return t8;
};
export default StatusBadge;